export enum Order {
    asc = 'asc',
    desc = 'desc'
}

export type SortingOrder = Record<string, Order>;
